import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=12675644&scoped=true"
import script from "./TicketItem.vue?vue&type=script&lang=js"
export * from "./TicketItem.vue?vue&type=script&lang=js"
import style0 from "./TicketItem.vue?vue&type=style&index=0&id=12675644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12675644",
  null
  
)

export default component.exports